import { AttributesMixin, define, Model, type } from "@type-r/models";

export interface Mapping extends AttributesMixin<typeof Mapping> { }

@define
export class Mapping extends Model {
  static attributes = {
    assetTypeId: Number,
    validationRuleId: Number,
    mappingItems: [type({
      from: type({
        name: String,
        x: Number,
        y: Number,
        isGlobal: Boolean,
        globalValuePosition: String,
        formatting: {
          name: String,
          value: String
        }
      }),
       to: type({
        name: String,
        id: String,
        targetFieldTypeId: Number
      })
    })]
  };
}
